import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from '@nextcloud/l10n'
import { NcButton } from '@nextcloud/vue'
import { useHotKey } from '@nextcloud/vue/composables/useHotKey'
import { useRoute, useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigationHeaderTodayButton',
  setup(__props) {

const route = useRoute()
const router = useRouter()

async function today(): Promise<void> {
	// Don't push new route when day didn't change
	if (route.params.firstDay === 'now') {
		return
	}

	const name = route.name!
	const params = {
		...route.params,
		firstDay: 'now',
	}

	await router.push({ name, params })
}

useHotKey('t', () => today())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcButton), {
    class: "today",
    onClick: today
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('calendar', 'Today')), 1)
    ]),
    _: 1
  }))
}
}

})